import { useMemo } from 'react';
import { Direction } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from 'config/i18n';
import { system_theme } from 'store/system/selectors';
import { config_getEnv } from 'store/config/selectors';
import { createCustomMuiTheme } from 'muiTheme/theme/createCustomMuiTheme';
import { primaryColors, secondaryColors } from 'muiTheme/theme/theme.constants';
import { resolvePalette } from './palette.utils';
import config from 'config/common';

function useColorsSettings() {
    const env = useSelector(config_getEnv);

    const primaryColor = env?.REACT_APP_PRIMARY_COLOR || config.primaryColor;
    const secondaryColor = env?.REACT_APP_SECONDARY_COLOR || config.secondaryColor;

    return {
        primaryColor,
        secondaryColor,
    };
}

export function useCustomMuiTheme() {
    const systemTheme = useSelector(system_theme);
    const {
        i18n: { language },
    } = useTranslation();
    const direction = getLanguageDirection(language) as Direction;

    const { primaryColor, secondaryColor } = useColorsSettings();

    const customMuiTheme = useMemo(
        () =>
            createCustomMuiTheme({
                primaryVariants: resolvePalette(primaryColor, primaryColors, primaryColors.blue),
                secondaryVariants: resolvePalette(secondaryColor, secondaryColors, secondaryColors.green),
                theme: systemTheme,
                direction,
            }),
        [primaryColor, secondaryColor, systemTheme, direction]
    );

    return customMuiTheme;
}
